// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type WithServerRetentionFragment = {
  __typename?: "Server";
  id: string;
  retentionInDays: number;
};

export const WithServerRetentionFragmentDoc = gql`
  fragment WithServerRetention on Server {
    id
    retentionInDays
  }
`;
